import { render, staticRenderFns } from "./TagCategoryEditModal.vue?vue&type=template&id=0068b52d"
import script from "./TagCategoryEditModal.vue?vue&type=script&lang=js"
export * from "./TagCategoryEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports